<template>
    <div>
        <div class="l-jackpot">
            <div class="l-jackpot-side">
                <div class="ui relaxed padded grid padding-top-md">
                    <div class="row">
                        <div class="column">
                            <button class="ui red fluid button">Create Ticket</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <div class="l-jackpot-list">
                                <!--<a  style="color: red" href="#" class="selected">Open Tickets</a>-->
                                <!--<a  style="color: #0ea432" href="#" class="">Closed Tickets</a>-->
                                <router-link  class="selected"  style="color: red" :to="{name: 'ticket'}">Open Tickets</router-link>
                                <router-link  class="selected" style="color: #0ea432" :to="{name: 'ticket'}">Closed Tickets </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="l-jackpot-content">

                <div class="ui relaxed padded grid padding-top-md">
                    <div class="equal width row">

                        <div class="column">
                            <div class="ui equal width grid">
                                <div class="column border-right" style="color: red">Open Issues: <strong>23</strong></div>
                                <div class="column border-right" style="color: #0ea432">Closed Issues: <strong>50</strong> </div>
                                <div class="column border-right"  > PERFORMANCE <strong> Very Good </strong></div>
                                <div class="column border-right">
                                    <i class="icon-calendar"></i>
                                    <input name="dates"  @focus="onFocus()"  placeholder="Choose date" />
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <div class="row">
                                <loader v-show='loading' />
                                <div class="col">
                                    <vuetable ref="vuetable"
                                              :api-url="vueurl"
                                              :fields="columns"
                                              :sort-order="sortOrder"
                                              :append-params="moreParams"
                                              :per-page="15"
                                              @vuetable:pagination-data="onPaginationData"
                                              @vuetable:loading="onLoading"
                                              @vuetable:loaded="onLoaded"
                                    >

                                        <template  v-slot:status-slot="props">

                                            <div  v-if="(props.rowData.status === '0' && !props.rowData.description)"><strong>PENDING</strong></div>
                                            <div  style="text-transform:uppercase;" v-if="(props.rowData.status === '0' && props.rowData.description)"><strong>{{props.rowData.description}}</strong></div>
                                            <div  v-if="props.rowData.status === '1'"><strong>SUCCESS</strong></div>

                                        </template>

                                        <template  v-slot:actions="props">
                                            <button class="ui blue button" @click="onActionClicked('edit', props.rowData)"><i class="fa fa-pencil"></i></button>
                                            <button class="ui green button" @click="onActionClicked('confirm', props.rowData)"> <i class="fa-check-square"></i></button>
                                        </template>



                                    </vuetable>
                                    <div class="vuetable-pagination ui basic segment grid">
                                        <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>

                                        <vuetable-pagination ref="pagination"
                                                             @vuetable-pagination:change-page="onChangePage"
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
    import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
    import loader from "@/components/loader"
    import {config} from '../config/config';



    export default {


        components: {
            Vuetable, VuetablePagination, VuetablePaginationInfo,loader,config
        },
        name: 'ticket',

        data() {
            return {
                vueurl:config.baseURL+'odibets/mpesa/reconcile',
                loading: true,
                selected_data: {},
                deposit_data:'',
                deposit_mpesa:'',
                columns: [
                    {
                        name: 'msisdn',
                        title: 'Phone number',
                        sortField: 'mp.msisdn',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'

                    },

                    {
                        name: 'mpesa_code',
                        title: 'MPESA Code ',
                        sortField: 'mp.mpesa_code',
                        titleClass: '',
                        dataClass: ''

                    },
                    {
                        name: 'mpesa_amt',
                        title: 'Deposit Amout  ',
                        sortField: 'mt.mpesa_amt',
                        titleClass: '',
                        dataClass: ''

                    },
                    {
                        name: 'status-slot',
                        title: 'status',
                        titleClass: '',
                        dataClass: '',

                    },

                    {
                        name: 'username',
                        title: 'CS Agent ',
                        titleClass: ''
                    },
                    {
                        name: 'transaction_time',
                        title: 'Date Deposited',
                        sortField: 'transaction_time',
                        callback: 'depositedAt'
                    },
                    'actions'


                ],
                range:'',
                user_id:'',
                role:'',
                token:'',
                search_match:'',
                sortOrder: [{
                    field: 'mp.created',
                    direction: 'desc'
                }],
                is_partial_resulting: false,
                moreParams: {
                    start: '',
                    filter: '',
                    end: '',
                    token: this.token,
                }

            }
        },


        mounted() {

            var vm=this;

            var start = moment();
            var end = moment();

            function cb(start, end) {
                vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                $('#reportrange span').html(start.format('D MMM, YYYY') + ' - ' + end.format('D MMM, YYYY'));
            }

            $('#reportrange').daterangepicker({
                startDate: start,
                endDate: end,
                autoApply:true,
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }
            }, cb);

            cb(start, end);

        },


        created: function(){

            var vm=this;


            vm.checktimer();

            var obj = window.localStorage.getItem('user_info');

            var jsonData = JSON.parse(obj);
            var rolee=jsonData.role;
            var userr=jsonData.id;
            var tokenn=jsonData.token;

            vm.role=rolee;
            vm.user_id=userr;
            vm.token=tokenn;

            if((vm.role  !=2 && vm.role !=3 && vm.role !=5)){

                vm.$router.push({name: 'login'});
            }

            var start = moment();
            var end = moment();

            vm.moreParams.start=start.format('YYYY-MM-DD');
            vm.moreParams.end=end.format('YYYY-MM-DD');
            vm.moreParams.token=vm.token;

        },





        watch: {
            data(newVal, oldVal) {
                this.$refs.vuetable.reload();
            },
            range(){

                var start = this.range[0];
                var end = this.range[1];
                this.start= moment(start).format('YYYY-MM-DD');
                this.end= moment(end).format('YYYY-MM-DD');
                console.log("am reaching here ")
                this.moreParams.start = this.start;
                this.moreParams.end = this.end;
                this.moreParams.token = this.token;
                this.$refs.vuetable.reload();
            }
        },



        methods: {




            checktimer:function(){
                var vm=this;
                const itemStr = localStorage.getItem("timer")
                // if the item doesn't exist, return null
                if (!itemStr) {
                    return null
                }
                const item = itemStr

                var checktimer = new Date(item);

                const now = new Date()
                // compare the expiry time of the item with the current time
                if (now.getTime() > checktimer.getTime()) {
                    // If the item is expired, delete the item from storage
                    // and return null
                    localStorage.removeItem("timer");
                    localStorage.removeItem("user_info");

                    const Toast = vm.$swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 9000
                    });
                    Toast.fire({
                        type: 'error',
                        title: "Your session expired, Please login again "
                    })

                    vm.$router.push({name: 'login'});
                    return null
                }

            },

            dateFilter: function (start, end) {

                var vm = this;


                vm.start = start;
                vm.end = end;


                vm.moreParams.start = vm.start;
                vm.moreParams.end = vm.end;
                vm.moreParams.token = vm.token;


                this.$refs.vuetable.reload();

                console.log("start date filter cheacker",vm.start)
                console.log("end date filter cheacker  ",vm.end)
            },

            onFocus: function() {

                var vm = this;

                var start = moment();
                var end = moment();

                function cb(start, end) {
                    vm.dateFilter(start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'));
                    $('input[name="dates"]').val(start.format('D MMMM, YYYY') + ' - ' + end.format('D MMMM, YYYY'));
                }

                $('input[name="dates"]').daterangepicker({
                    startDate: start,
                    endDate: end,
                    ranges: {
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                        'This Month': [moment().startOf('month'), moment().endOf('month')],
                        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                    }
                }, cb);

                cb(start, end);

            },



            createdAt: function (value) {
                if (!value) {
                    return '-';
                } else {
                    return moment(value).format('h:mm a,DD MMM YYYY');
                }

            },




            onPaginationData(paginationData) {
                this.$refs.paginationInfo.setPaginationData(paginationData)
                this.$refs.pagination.setPaginationData(paginationData)
            },


            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },


            onLoading() {
                this.loading = true
                console.log('loading... show your spinner here')
            },
            onLoaded() {
                this.loading = false
                console.log('loaded! .. hide your spinner here')
            },




        },


    }

</script>